import PropTypes from 'prop-types';

import { paletteTypes } from '../../../styles';

const noop = () => {};

export const propTypes = {
  style: PropTypes.object,
  color: PropTypes.oneOf(paletteTypes),
  size: PropTypes.oneOf([
    'default',
    'small',
    'large',
  ]),

  children: PropTypes.node,
  label: PropTypes.node,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,

  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseDown: PropTypes.func,

  isActive: PropTypes.bool,
  isRaised: PropTypes.bool,
  disabled: PropTypes.bool,

  href: PropTypes.string,
  navTo: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
  ]),

  iconOffsetLeft: PropTypes.number,
  iconOffsetRight: PropTypes.number,
};

export const defaultProps = {
  style: {},
  color: 'default',
  size: 'default',

  children: undefined,
  label: '',
  leftIcon: undefined,
  rightIcon: undefined,

  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onMouseDown: noop,

  isActive: false,
  isRaised: false,
  disabled: false,

  href: undefined,
  navTo: undefined,

  iconOffsetLeft: 0,
  iconOffsetRight: 0,
};



// WEBPACK FOOTER //
// ./src/components/ui/Button/types.js